import { RootState } from '@/store/reducers/rootReducer'

export const simulationSelector = (state: RootState) => state.simulation
